module.exports = __webpack_public_path__ + "img/yinhai_subject.c120e24a.jpg";